import React from "react";
import "./All_Time_Fav.css";
import Product_card from "../../common-components/product_card/Product_card";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import { useNavigate } from "react-router-dom";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";

function All_Time_Fav({ products }) {
  const navigate = useNavigate();

  console.log("products", products);

  const handleToggle = () => {
    navigate("/categories");
  };

  return (
    <section className="All_Time_Fav">
      <div className="container">
        <h4 className="heading_text">Best Sellers</h4> 

        <div className="all_prods_holder">
          {products && products.length > 0 ? (
            <div className="row">
              {products.map((product, index) => (
                <div className="col-lg-3 col-md-4 col-6 p-1">
                  <div className="product_card_holder">
                    <Product_Info_Card
                      product={product} 
                      id={product.id}
                      imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                      productName={product.name}
                      priceText={product.Product_Variants[0]?.price}
                      mrp={product.Product_Variants[0]?.mrp}
                      kgText={product.Product_Variants[0]?.name}
                      savingPrice={
                        parseFloat(product.Product_Variants[0]?.mrp || 0) -
                        parseFloat(product.Product_Variants[0]?.price || 0)
                      }
                    />
                  </div>
                </div>
              ))}

              {products.length > 3 && (
                <div className="text-center">
                  <Green_btn btnText="View all" onClick={handleToggle} />
                </div>
              )}
            </div>
          ) : (
            <div className="no_product_available_holder text-center w-100">
              <h3>No Product Added In All-Time Favs</h3>
            </div>
          )}
        </div>

        {/* old code */}
        {/* <div className="heading_holder"> 
          <h4>All-Time Favs</h4>
        </div> 

        <div className="row">
          {products && products.length > 0 ? (
            <>
              <div className="row">
                {products.map((product, index) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6 col-6 px-md-2 px-1"
                    key={index}
                  >
                    <Product_card
                      product={product}
                      id={product.id}
                      imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                      productName={product.name}
                      priceText={product.Product_Variants[0]?.price}
                      kgText={product.Product_Variants[0]?.name}
                      savingPrice={
                        parseFloat(product.Product_Variants[0]?.mrp || 0) -
                        parseFloat(product.Product_Variants[0]?.price || 0)
                      }
                    />
                  </div>
                ))}
              </div>

              {products.length > 3 && (
                <div className="text-center mt-4">
                  <Green_round_btn btnText="See More" onClick={handleToggle} />
                </div>
              )}
            </>
          ) : (
            <div className="no_product_available_holder text-center w-100">
              <h3>No Product Added In All-Time Favs</h3>
            </div>
          )}
        </div>

        */}
      </div>
    </section>
  );
}

export default All_Time_Fav;
